import './static/css/about.css';
import Illustration from './static/img/illustration.svg';

const About = () => {
     return (
          <div class="col-xxl-8 contact container p-5">
               <div class="align-items-center flex-lg-row-reverse g-5 py-5 row">
                    <div class="col-10 col-lg-6 col-sm-8 d-none d-lg-flex">
                         <img alt="Ilustração" class="d-block illustation img-fluid mx-lg-auto" loading="lazy" src={Illustration} />
                    </div>
                    <div class="col-lg-6">
                         <h1 class="display-5 fw-bold lh-1 mb-3 text-body-emphasis title">
                              Um pouco sobre n&oacute;s
                         </h1>
                         <p class="lead mt-4">
                              Somos uma empresa de tecnologia especializada no desenvolvimento e atualiza&ccedil;&atilde;o de sistemas para laborat&oacute;rios de an&aacute;lises cl&iacute;nicas. Fundada em 1993, a empresa tem como miss&atilde;o otimizar processos laboratoriais atrav&eacute;s de solu&ccedil;&otilde;es tecnol&oacute;gicas inovadoras, garantindo maior precis&atilde;o, efici&ecirc;ncia e seguran&ccedil;a na gest&atilde;o de dados e an&aacute;lises.
                         </p>
                         <div class="d-grid d-md-flex gap-2 justify-content-md-start mt-4">
                              <a href="#">
                                   <button class="border-0 btn btn-lg btn-primary me-md-2 px-4 py-3 rounded-pill w-100" type="button">
                                        Solu&ccedil;&atilde;o Madya
                                   </button>
                              </a>
                              <a href="#">
                                   <button class="btn btn-lg btn-outline-secondary px-4 py-3 rounded-pill w-100" type="button">
                                        Fale conosco
                                   </button>
                              </a>
                         </div>
                    </div>
               </div>
          </div>
     );
}

export default About;